import { isObject } from 'lodash-es';
import React from 'react';

//eslint-disable-next-line @typescript-eslint/no-explicit-any
export const usePostMessageListener = (eventName: string, callBack: (data: any) => void) => {
  React.useEffect(() => {
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    const messageFunction = (event: MessageEvent<any>) => {
      if (
        event.data != null &&
        isObject(event.data) &&
        'type' in event.data &&
        'data' in event.data
      ) {
        if (event.data?.type === eventName) {
          callBack(event.data?.data);
        }
      }
    };
    window.addEventListener('message', messageFunction);
    return () => {
      window.removeEventListener('message', messageFunction);
    };
  }, [eventName, callBack]);
};
